import React from 'react';
import { useDispatch } from 'react-redux';

import Img from '../../../components/Img';
import { ballTypeIds } from '../../../utils/eventConstants';
import { postColorballSurveyV2 } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';

const ColorBallType = () => {
    const dispatch = useDispatch();

    const handleSubmit = (ballType) => {
        const payload = {
            ballType,
        };
        dispatch(postColorballSurveyV2(payload));
    };

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.color-ball-type.title">
                What type of ball do you play with?
            </div>
            <div className={styles.description} data-testid="nuo-v2.color-ball-type.description">
                Please select the ball color you are currently or plan to start playing tennis with.
            </div>
            <div className="mt16">
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={() => handleSubmit(ballTypeIds.GREEN)}
                    data-testid="nuo-v2.color-ball-type.green-btn"
                >
                    <div className={styles.ballIcon}>
                        <Img src={'/img/progression_ball_green.svg'} />
                    </div>
                    Green
                </button>
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={() => handleSubmit(ballTypeIds.ORANGE)}
                    data-testid="nuo-v2.color-ball-type.orange-btn"
                >
                    <div className={styles.ballIcon}>
                        <Img src={'/img/progression_ball_orange.svg'} />
                    </div>
                    Orange
                </button>
                <button
                    type="button"
                    className="btn btn-primary btn-block btn-lg text-uppercase"
                    onClick={() => handleSubmit(ballTypeIds.RED)}
                    data-testid="nuo-v2.color-ball-type.red-btn"
                >
                    <div className={styles.ballIcon}>
                        <Img src={'/img/progression_ball_red.svg'} />
                    </div>
                    Red
                </button>
            </div>
        </div>
    );
};

export default ColorBallType;
